"use strict";
var ACC;
ACC.hopdebug = {

	bindAll: function ()
	{
		this.bindShowDebugMode();
	},

	bindShowDebugMode: function ()
	{
		var debugModeEnabled = $('#hopDebugMode').data("hopDebugMode");
		
		if (!debugModeEnabled && !$('#showDebugPage').attr('value'))
		{
			$('#hostedOrderPagePostForm').submit();
		}
	}
};


$(document).ready(function ()
{
	ACC.hopdebug.bindAll();
});